import { createContext } from 'react';

const ScreenSizeContext = createContext({ size: null });

export default ScreenSizeContext;
